"use client";
import React, { useState, useEffect, useCallback } from 'react';
import Image from 'next/image';
import "@/scss/_article.scss";
import profileIcon from '../../../public/icons/profile.svg';
import { getSimilarArticles } from '@/services/publicService';
import { convertInto120Words, convertIntoString } from '@/services/constantService';
import Link from 'next/link';

const SimilarArticleSection = ({type, slug}) => {
  const [similarArticles, setSimilarArticles] = useState([]);
  const [contentType] = useState(type === 'market-insights' ? 'market-insight' : (type || ''));
  const getSimilarArticlesData = useCallback(async () => {
    const response = await getSimilarArticles(type, slug);
    setSimilarArticles(response.data); 
  }, []);


  useEffect(() => {
    getSimilarArticlesData();
  }, []);
  return (
    <section className="related-articles-section">
        <div className="container-fluid custom-wrapper article-content-container">
          <h2 className="related-articles-title text-center">You Might Also Like</h2>
          <div className="row mt-5">
            {similarArticles?.map((article, key) => (
              <div key={article.id} className="col-lg-4 col-md-6 mb-4">
                <div className="related-article-card">
                  <div className="related-article-image">
                    <div className="article-image-placeholder">
                      {article?.image?.url ? (
                        <Image src={article?.image?.url} alt="Article" width={300} height={200} className="img" />
                      ) : null}
                    </div>
                  </div>
                  <div className="related-article-content">
                    <h3 className="related-article-title"><Link href={`/${contentType}/${article.slug}`} target='_blank' style={{textDecoration: 'none', color: '#0C0C0C'}}>{convertIntoString(article?.title)}</Link></h3>
                    <p className="related-article-description" dangerouslySetInnerHTML={{ __html: convertInto120Words(article?.readmore_description) }} />
                      <Link href={`/${contentType}/${article.slug}`} target='_blank' className="related-article-link">
                        Read More
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6 12l4-4-4-4" stroke="#0C0C0C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </Link>
                    
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
  );
}

export default SimilarArticleSection;
